import { Onboarding } from '@interfaces'
import { api } from '@utils/api/api'

export const getOnboardingStatus = (): Promise<Onboarding> => {
  return api.get('/api/v1/customers/me/onboarding-status')
}
